<template>
  <transition name="slide-down">
    <div
      v-if="appear & show"
      role="dialog"
      aria-labelledby="dialogFeedback"
      class="rc-rating"
      :class="mode == 'setRating' ? 'rc-rating-set' : 'rc-rating-thanks'"
    >
      <h2 id="dialogFeedback" class="visually-hidden">
        {{ $t("common.feedback") }}
      </h2>
      <div class="row" aria-live="polite" aria-atomic="true">
        <template v-if="mode == 'setRating'">
          <div class="col">
            <fieldset class="form-group">
              <div class="row">
                <legend class="col-auto bv-no-focus-ring col-form-label">
                  {{ $t("catalog.rating.question") }}
                  <span class="visually-hidden">{{
                    $t("catalog.rating.stars_number")
                  }}</span>
                </legend>

                <div class="col">
                  <div
                    class="rc-stars-container me-2"
                    @keydown="handleKeyDown"
                    tabindex="0"
                  >
                    <div class="d-flex">
                      <span
                        v-for="(star, index) in totalStars"
                        :key="star"
                        class="rc-star-rating d-flex mx-2"
                        :class="{ 'star-filled': star <= currentRating }"
                        :aria-label="
                          $tc('catalog.rating.rate', {
                            n: star
                          })
                        "
                        @click="handleClick(star)"
                        @keyup.enter="handleClick(star)"
                      >
                        <RcIcon
                          scale="1.7"
                          :name="star <= currentRating ? 'starFill' : 'star'"
                        ></RcIcon>
                      </span>
                    </div>
                    <span class="visually-hidden">
                      {{
                        $tc("catalog.rating.stars_count", currentRating, {
                          n: currentRating
                        })
                      }}</span
                    >
                  </div>

                  <button
                    class="rc-btn-submit-rating btn btn-sm btn-light ms-2"
                    @click="onSubmit(currentRating)"
                  >
                    {{ $t("common.submit") }}
                  </button>
                </div>
              </div>
            </fieldset>
          </div>
        </template>
        <template v-if="mode == 'thanks'">
          <div class="col-auto">
            <RcIcon
              name="success"
              fontScale="250"
              class="text-success"
            ></RcIcon>
          </div>

          <div class="col-auto rc-col-thanks">
            <div class="rc-thanks-msg me-3">
              {{ $t("catalog.rating.thanks") }}
            </div>
            <div>
              <span class="visually-hidden">
                {{
                  $tc("catalog.rating.stars_count", currentRating, {
                    n: currentRating
                  })
                }}
              </span>
              <ol class="d-flex py-1" aria-hidden="true">
                <li
                  class="mx-1"
                  v-for="(star, index) in totalStars"
                  :key="index"
                >
                  <RcIcon
                    scale="1"
                    name="starFill"
                    :class="currentRating > index ? '' : 'text-light'"
                  ></RcIcon>
                </li>
              </ol>
            </div>
          </div>
        </template>
      </div>
      <button
        class="rc-btn-icon rc-btn-close btn btn-link"
        @click="show = false"
      >
        <span class="visually-hidden">{{ $t("common.close") }} </span>
        <RcIcon name="close"></RcIcon>
      </button>
    </div>
  </transition>
</template>

<script>
import RcIcon from "@/libvue/components/icons/Base.vue";

export default {
  name: "RcRating",
  components: {
    RcIcon
  },
  props: {
    uid: {
      type: String,
      required: true
    },

    appear: {
      type: Boolean,
      default: false
    },

    totalStars: {
      type: Number,
      default: 5
    }
  },
  emits: ["change"],
  data() {
    return {
      show: true,
      mode: "setRating",
      currentRating: 0
    };
  },
  watch: {
    uid() {
      this.mode = "setRating";
      this.rating = 0;
    }
  },
  methods: {
    handleKeyDown(event) {
      if (event.key === "ArrowRight" && this.currentRating < this.totalStars) {
        this.currentRating += 1;
      } else if (event.key === "ArrowLeft" && this.currentRating > 0) {
        this.currentRating -= 1;
      }
    },
    handleClick(rating) {
      this.currentRating = rating;
    },

    onSubmit(rating) {
      this.mode = "thanks";
      this.$emit("change", rating);
    }
  }
};
</script>

<style lang="scss" scoped></style>
